export const NAT_TYPE_MAP = {
  '0': '其它',
  '1': '公网型',
  '2': '全锥型',
  '3': 'IP限制型',
  '4': '端口限制型',
  '5': '对称型',
  '5.1': '对称型',
  '6': '映射公网型',
};
export const PRODUCT_TYPE_MAP = {
  // "WxBox" :    "网心盒子",
  WkyC: '玩客云现金版',
  XA: '小爱盒子',
  x86: 'x86',
  SF: '三方盒子',
  // "WxOpen":    "网心云开放版",
  ZQB3pro: '玩客云-赚钱宝3代pro',
  // "ZQBPC" :     "赚钱宝电脑版",
  PC: '赚钱宝电脑版',
  // "WJY"   :    "我家云",
};
export const DEVICE_TYPE_MAP = {
  '-1': '未知',
  '1': '玩客云',
  '2': '三方盒子',
  '3': '我家云',
  '4': '玩客云pro',
  '5': 'x8',
};

export const NAT_UPNP_MAP = {
  '-1': '不可用',
  '1': '可用',
};
